import React, { useEffect, useState } from 'react';
import VideoPage from './VideoPage';
import { useDispatch } from 'react-redux';
import {
    fetchVideo,
    updateTagList
} from '../VideoPage/VideoPage.action';

const VideoPageContainer = (tagList) => {
    const dispatch = useDispatch();
    const [videoList, setVideoList] = useState([]);

    const fetchVideos = async () => {
        const videos = await dispatch(fetchVideo());
        setVideoList(videos);
    };

    const storeTagList = () => {
        dispatch(updateTagList(tagList));
    };

    useEffect(() => {
        fetchVideos();
        storeTagList();
    }, []);

    return (
        <div className="grid-system grid-system-within-boundaries">
            {videoList.length > 0 &&
                <VideoPage />
            }
        </div>
    );
};

export default VideoPageContainer;